import {endpoint} from '~/api';
import {IPaginator} from '~/lib/paginator';
import {EntityType, IAudit, OperationType} from '~/modules/Audit/models/Audit';

export interface IAuditPaginator {
    pageNo?: number;
    pageSize?: number;
}

export interface IAuditFilter {
    userId?: string;
    entityId?: string;
    entityType?: EntityType | null;
    operationType?: OperationType | null;
}

const setUrlParam = <T extends any>(params: URLSearchParams, obj: T, field: keyof T, ) => {
    if (obj[field]) {
        params.set(field.toString(), obj[field].toString());
    }
};

export const fetchAudit = (filter: IAuditFilter, paginator: IAuditPaginator) => {
    const params = new URLSearchParams();
    setUrlParam<IAuditPaginator>(params, paginator, 'pageNo');
    setUrlParam<IAuditPaginator>(params, paginator, 'pageSize');

    setUrlParam<IAuditFilter>(params, filter, 'userId');
    setUrlParam<IAuditFilter>(params, filter, 'entityId');
    setUrlParam<IAuditFilter>(params, filter, 'entityType');
    setUrlParam<IAuditFilter>(params, filter, 'operationType');

    return endpoint.get<IPaginator<IAudit>>(`/audit?${params.toString()}`).then(r => r.data);
};
